const { ToggleButtonComponentDefinition } = require('./toggle-button.component');

require('angular')
    .module('wowApp.common')
    .component('wowToggleButton', ToggleButtonComponentDefinition);



// WEBPACK FOOTER //
// ./src/common/togglebutton/index.js